import angular from 'angular';
import csmHttp from '../CSMHttp/CSMHttp';

export default angular
  .module('csm.util.CommonSvc', [csmHttp])
  .factory('CommonSvc', commonSvcFactory).name;

commonSvcFactory.$inject = ['CSMHttp'];
/*******************************************************************************
 * commonSvcFactory */
/**
 * Factory object that will provide Common service calls. The server should be
 * set up to handle "CommonSvc.ashx" as the destination.
 *
 * The base handler path is provided via the getBaseUrl function. This factory
 * can be extended for other objects which then would have to provide their own
 * definition for getBaseUrl.
 *******************************************************************************/
/* @ngInject */ function commonSvcFactory(CSMHttp) {
  return {
    /** To be overridden when extended to point to appropriate url. */
    getBaseUrl: function () {
      return 'CommonSvc.ashx/';
    },

    /** Handler Methods */
    acceptLicense: function () {
      return CSMHttp.doGet(this.getBaseUrl() + 'acceptLicense');
    },
    authenticateUser: function (un, pw, orgID) {
      return CSMHttp.doPost(this.getBaseUrl() + 'authenticateUser', {
        username: un,
        password: pw,
        orgID: orgID
      });
    },
    getMenu: function () {
      return CSMHttp.doGet(this.getBaseUrl() + 'getMenu');
    },
    getOrgs: function () {
      return CSMHttp.doGet(this.getBaseUrl() + 'getUserOrgs');
    },
    getUsername: function () {
      return CSMHttp.doGet(this.getBaseUrl() + 'getUsername');
    },
    getUserProfile: function () {
      return CSMHttp.doGet(this.getBaseUrl() + 'getUserProfile');
    },
    logout: function () {
      return CSMHttp.doGet(this.getBaseUrl() + 'logout');
    },
    resetPassword: function (username, productID) {
      return CSMHttp.doPost(this.getBaseUrl() + 'resetPassword', {
        username: username,
        productID: productID
      });
    },
    switchOrg: function (orgID) {
      return CSMHttp.doPost(this.getBaseUrl() + 'switchOrganization', {
        orgID: orgID
      });
    },
    updateCredentials: function (cred) {
      return CSMHttp.doPost(this.getBaseUrl() + 'updateCredentials', cred);
    },
    updateProfile: function (profile) {
      return CSMHttp.doPost(this.getBaseUrl() + 'updateProfile', profile);
    }
  };
}
